import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    update: async ({ age, education, industry, job_title, income, gender, timezone, country, bio, birth_year, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "userdemographic";

        const body = JSON.stringify({
            ...(age !== undefined && { age }),
            ...(education !== undefined && { education_id: education }),
            ...(industry !== undefined && { industry_id: industry === 0 ? null : industry }),
            ...(job_title !== undefined && { job_title: job_title }),
            ...(income !== undefined && { income_id: income }),
            ...(gender !== undefined && { gender_id: gender }),
            ...(timezone !== undefined && { timezone }),
            ...(country !== undefined && { country_id: country }),
            ...(bio !== undefined && { bio }),
            ...(birth_year !== undefined && { birth_year: birth_year }),
        });

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    show: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "userdemographic";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


}